module.exports = __webpack_public_path__ + "static/media/custom-rtmp.ac31c129.svg";